import { FormControlLabel } from '@material-ui/core';
import { LongBody, ShortBody } from 'components/Typography';
import { OrangeButton } from 'components/Button';
import React from 'react';
import styled from 'styled-components';

export const StyledFormControlLabel = styled(({ checked, ...otherProps }) => (
  <FormControlLabel {...otherProps} />
))`
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.08);
  width: 100%;
  padding: 14px 28px;
  margin-bottom: 15px;
  box-sizing: border-box;
  border: ${(props) =>
    props.checked ? '1px solid #FCB718' : '1px solid #fff'};
  && .MuiIconButton-root {
    margin-right: 8px !important;
  }
`;
export const InlinedLongBody = styled(({ reverse, ...otherProps }) => (
  <LongBody {...otherProps} />
))`
  display: inline-block;
  margin-bottom: 4px !important;
  margin-right: ${(props) => (props.reverse ? '8px' : '0px')} !important;
  margin-left: ${(props) => (props.reverse ? '0px' : '8px')}!important;
  position: relative;
  top: -5px;
`;

export const StyledShortBody = styled(ShortBody)`
  margin-bottom: 0px !important;
`;

export const StyledOrangeButton = styled(OrangeButton)`
  && {
    margin-top: 64px;
    margin-bottom: 44px;
  }
`;
